import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=055cf824&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"
import style0 from "./Statistic.vue?vue&type=style&index=0&id=055cf824&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cf824",
  null
  
)

export default component.exports